import { responsive } from "../../helpers";
var Layout = {
  container: {
    margin: "0 auto",
    paddingX: 4,
    width: "100%",
    maxWidth: responsive({
      xs: "100%",
      sm: "100%",
      md: "640px",
      lg: "768px",
      xl: "1024px",
      xxl: "1280px"
    })
  }
};
export default Layout;